module.exports = __webpack_public_path__ + "img/uploadfile.c4a50a39.svg";